// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalProjects_container__1L1b4","title":"PersonalProjects_title__3ojSD"};